import { Component } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {Config, ConfigService } from '../config/config.service';
import { Router, NavigationEnd,NavigationStart,  ActivatedRoute } from '@angular/router'
import {trigger, animate, style, group, animateChild, query, stagger, transition} from '@angular/animations';
import { TamasAlunoService } from '../app/tamas-aluno.service';
import { ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { MessagingService } from "./messaging.service";

declare function infoMov(action): any;
declare function infoLoaded(): any;

// Animations
const fade = [
  query(':self', 
    [
      style({ opacity: 0 })
    ], 
    { optional: true }
  ),

  query(':self',
    [
      style({ opacity: 0 }),
      animate('.3s', style({ opacity: 1 }))
    ], 
    { optional: true }
  )
];

const left = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
      query(':enter', [style({ transform: 'translateX(-100%)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
          optional: true,
      }),
      query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(100%)' }))], {
          optional: true,
      }),
  ]),
];

const right = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
      query(':enter', [style({ transform: 'translateX(100%)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
          optional: true,
      }),
      query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(-100%)' }))], {
          optional: true,
      }),
  ]),
];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  // animations: [
  //   trigger('routerAnimations', [
  //     transition('* => *', fade)
  //   ])
  // ]
  animations: [
    trigger('animRoutes', [
      transition(':increment', right),
      transition(':decrement', left),
    ]),
],
})
export class AppComponent {
  title = 'webapp-tamas-aluno';
  config: Config;
  pageState: any;
  animationState: number;
  mBusca: boolean = false;
  mFull: boolean;
  mgCond: any;
  brSafari: boolean = true;
  mX1: boolean = false;
  isDarkTheme: Observable<boolean>;
  qNomeUserLogado: any = '';
  urlLoja: any = '';
  message;
  constructor(private http: HttpClient, public router: Router,  private route: ActivatedRoute, public tmaService: TamasAlunoService,private cdRef:ChangeDetectorRef,  private messagingService: MessagingService) {
    
      this.router.events.subscribe(event => {
        if(event instanceof NavigationStart) {
          
          
        }
        if (event instanceof NavigationEnd) {
          // setTimeout(() => {
          //   //exibir modal
          //   this.tmaService.exibeAlertaService("bora");
          // }, 3000);
          //alterar o link de navegação para a loja
          //remover isso cause impacto na performance (memory)
          if(this.tmaService.shopCidade != ''){
            this.urlLoja = '/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-');
          }
          else{
              this.urlLoja = '/pre-shop/uf';
          }
          //restringir algumas páginas, enviar somente as relevantes
          console.log(event.urlAfterRedirects);
          (<any>window).ga('set', 'page', event.urlAfterRedirects);
          (<any>window).ga('send', 'pageview');
         
          //this.mX1 = true;
          if(this.tmaService.logado){
            this.mX1 = true;
            this.qNomeUserLogado = this.tmaService.hcNomeUsuario;
            console.log("already logged");
            if(event.url == '/autenticar'){
              console.log("dont come back to auth");
              this.router.navigate(['/home']);
            }
          }
          else{
            //não precisa estar autenticado pra ver as páginas
            if(event.url == '/abertura'){

            }
            else if(event.url.indexOf('/abertura/') !== -1){

            }
            else if(event.url.indexOf('/recuperar-senha/') !== -1){
              console.log("oh thats good");
            }
            else if(event.url == '/premium'){

            }
            else if(event.url == '/contato'){
              
            }
            else if(event.url == '/negocios'){
              
            }
            else if(event.url == '/termos-de-uso'){
              
            }
            else if(event.url == '/excluir-conta'){
              
            }
            else if(event.url == '/'){

            }
            else if(event.url == '/login'){

            }
            else if(event.url == '/cadastrar'){
              
            }
            else if(event.url == '/autenticar'){

            }
            else if(event.url.includes('/meu-cadastro/s/2/')){
              console.log("auth not needed");
            }
            else if(event.url.includes('/meu-cadastro/s/1/')){
              console.log("auth not needed");
            }

            else if(event.url.includes('/auth-tamasapp/')){
              console.log("auth not needed");
            }

            // if(event.url !== '/autenticar'){
            //   this.tmaService.paginaAnterior = event.url;
            //   console.log("pre auth");
            //   console.log(event.url);
            //   this.router.navigate(['/autenticar']);
            // }
            else{
              this.tmaService.paginaAnterior = event.url;
              console.log("pre auth");
              console.log(event.url);
              this.router.navigate(['/autenticar']);
            }
          }
        }
      });


  }

 
  ngOnInit(){
    //this.meuScript('../../assets/js/postmsg.js');
    this.isDarkTheme = this.tmaService.isDarkTheme;
    //linha abaixo pergunta logo de cara
    var novaDD = new Date();
    const userId = 'user' + novaDD.getTime();
    this.messagingService.requestPermission(userId, 0);
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;

    //alert(window.navigator.userAgent);
    //check if safari
    //  if(/Macintosh|iPad|iPhone/.test(window.navigator.userAgent)){

    //  }
    //teste
    
    if(this.tmaService.shopCidade != ''){
      this.urlLoja = 'shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade;
    }
    else{
        this.urlLoja = 'pre-shop/uf';
    }
    if(!this.tmaService.logado){
      //console.log("pre auth");
      //console.log(this.router.url);
      
    }
    else{
      
    }
  }
  
  ngAfterViewChecked(){
    this.tmaService.modoFChange.subscribe(acao =>{
      this.mFull = acao;
      if(acao){
         this.mgCond = 3;
      }
      else{
        this.mgCond = 2;
      }
    })
    this.cdRef.detectChanges();

  }
  public meuScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.type = 'text/javascript';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  onActivate($event) {
    console.log("animação");
    infoLoaded();
    this.animationState = this.route.firstChild.snapshot.data['routeIdx'];
    infoMov("tmsnavigate:" + this.router.url);
  }
  prepareRouteTransition(outlet) {
    //console.log(outlet.activatedRouteData['animation']);
    const animation = outlet.activatedRouteData['animation'] || {};
    return animation['value'] || null;
  }

  toggleDarkTheme(checked: boolean) {
    console.log("foi");
    this.tmaService.setDarkTheme(checked);
  }


  goLoja() :void{
    if(this.tmaService.shopCidade != ''){
        //this.urlLoja = 'shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade;
        this.router.navigate(['shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade]);
    }
    else{
        //this.urlLoja = 'pre-shop/uf';
        this.router.navigate(['pre-shop/uf']);
    }
  }
}

@Component({
  selector: 'top-logofull-comp',    
  template: `
    <div class="bloco_grid">
    <div class="bloco_logo_s">
    <img src="../../assets/img/letraT_w.png" class="logo_topo_simb_solto" />
    <img src="../../assets/img/letraT_v.png" class="logo_topo_simb_solto_v" />
     </div>
    <div class="bloco_logo_l">
    <img src="../../assets/img/tamas-escrita.png" class="logo_topo_f_w" /> 
      <img src="../../assets/img/tamas-escrita.png" class="logo_topo_f" />
    </div>
    </div>
      `
  })
  export class LogotipoFullComponent{}

  @Component({
    selector: 'top-logomin-comp',    
    template: `
      <img src="../../assets/img/letraT_w.png" class="logo_topo_simb" />
      <img src="../../assets/img/letraT_v.png" class="logo_topo_simb_v" />
        `
    })
    export class LogotipoMinComponent{}

    @Component({
    selector: 'loading-padrao',    
    template: `
    <div class="cep_spin">
      <mat-spinner ></mat-spinner>
      <span style="display: block;">Carregando, aguarde...</span>
    </div>
        `
    })
    export class LoadingPadraoComponent{}